import { render, staticRenderFns } from "./confirmBook.vue?vue&type=template&id=bcea53b4&scoped=true&"
import script from "./confirmBook.vue?vue&type=script&lang=js&"
export * from "./confirmBook.vue?vue&type=script&lang=js&"
import style0 from "./confirmBook.vue?vue&type=style&index=0&id=bcea53b4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bcea53b4",
  null
  
)

export default component.exports